// Generated by Melange

import * as Fx from "../../fx/fx.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Subsonic__Empty from "./empty.jsx";
import * as Subsonic__Utils from "./utils.jsx";

function make(param) {
  const params = {};
  return Fx.Monad_syntax.let$star((Stdlib__Option.iter((function (albumId) {
    params["albumId"] = {
      TAG: /* Value */ 1,
      _0: albumId
    };
  }), param.albumId), Stdlib__Option.iter((function (artistId) {
    params["artistId"] = {
      TAG: /* Value */ 1,
      _0: artistId
    };
  }), param.artistId), Stdlib__Option.iter((function (id) {
    params["id"] = {
      TAG: /* Value */ 1,
      _0: id
    };
  }), param.id), Subsonic__Utils.makeRequest({
    _method: "rest/unstar",
    params: params
  }, Subsonic__Empty.of_json)), (function (param) {
    return {
      TAG: /* Ok */ 0,
      _0: undefined
    };
  }));
}

export {
  make,
}
/* No side effect */
